/**
 * Types and enums for the invitation router
 */

export enum InvitationStatus {
  DETECTING = 'detecting',
  ROUTING = 'routing',
  FALLBACK = 'fallback',
}

export enum DeviceType {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export interface InvitationRouterState {
  status: InvitationStatus;
  countdown: number;
}

export interface DeviceDetectionResult {
  isMobile: boolean;
  isTablet: boolean;
  deviceType: DeviceType;
}
